import styled from 'styled-components'
import {
  flexDirection,
  FlexDirectionProps,
  margin,
  MarginProps,
  maxWidth,
  MaxWidthProps,
  padding,
  PaddingProps,
  width,
  WidthProps,
} from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { gap, GapProps } from 'Services/Styles'

const shouldForwardProp = (prop: string) =>
  !DIV_SHOULD_FORWARD_PROP.includes(prop)

export const Container = styled.div.withConfig({ shouldForwardProp })<
  FlexDirectionProps & WidthProps & PaddingProps & MaxWidthProps & GapProps
>`
  display: flex;
  width: 100dvw;

  ${flexDirection}
  ${padding}
  ${maxWidth}
  ${gap}
`

export const Divider = styled.div<MarginProps>`
  width: 100%;
  height: 1px;
  background-color: ${themeGet('colors.line.tertiary')};

  ${margin}
`

export const ImageHolder = styled.div<WidthProps>`
  display: flex;
  overflow: hidden;
  flex-grow: 1;

  ${width}

  img {
    position: relative !important;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const StyledLink = styled.a`
  text-decoration: none;
  color: ${themeGet('colors.primary.main')};

  > svg {
    width: 20px;
    height: 20px;
  }
`
